import React from 'react';
import { useHistory } from 'react-router';
import { Button, Card, IconName } from '@vwfs-bronson/bronson-react';
import { openInNewWindow, useAnalyticsActionTracker } from '@cp-shared-15/frontend-ui';
import { MarketingCard } from 'cpie-common';

type MarketingCardComponentProps = {
    content: MarketingCard;
    buttonUrl: string;
    shouldOpenLinkInNewWindow?: boolean;
    testId?: string;
    minHeight?: number;
};

export const MarketingCardComponent: React.FC<MarketingCardComponentProps> = ({
    content,
    buttonUrl,
    shouldOpenLinkInNewWindow,
    testId,
    minHeight,
}) => {
    const { onAction } = useAnalyticsActionTracker('onLearnMore');
    const history = useHistory();
    const { title, imageUrl, text, buttonLabel } = content || {};

    const onButtonClick = (): void => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (shouldOpenLinkInNewWindow) openInNewWindow(buttonUrl)({} as any);
        else history.push(buttonUrl);
        onAction(title);
    };

    const additionalProps = {
        ...(minHeight ? { style: { minHeight: `${minHeight}px` } } : {}),
    };

    return (
        <Card
            title={title}
            imageSrc={((imageUrl as unknown) as { href: string })?.href}
            footer={true}
            className={'u-mb'}
            testId={testId}
            {...additionalProps}
            buttons={
                <Button
                    type="button"
                    link={true}
                    icon={IconName.FORWARD}
                    iconReversed
                    small
                    testId={`${testId}-button`}
                    onClick={onButtonClick}
                >
                    {buttonLabel}
                </Button>
            }
        >
            <div dangerouslySetInnerHTML={{ __html: text }} />
        </Card>
    );
};
